import { useGetTransactionsQuery } from '@/features/slice/accounting/transaction';
import { useUrlPagination } from '@/hooks';

export const useTransactionsReport = () => {
    const { page, limit } = useUrlPagination();

    const { data, isLoading, isFetching, isError, error } =
        useGetTransactionsQuery({
            page,
            limit,
        });
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
